import { useFlags } from "launchdarkly-react-client-sdk";
import { AppContext, useApp } from "./useApp";
import siteConfig from "../site-config";

type HasBuildOrderEnabledOptions = {
    flags: ReturnType<typeof useFlags>;
    scope: AppContext["scope"];
    me: AppContext["me"];
    ignoreNewPdp?: boolean;
};

export const hasBuildOrderEnabled = ({ scope, me, flags, ignoreNewPdp }: HasBuildOrderEnabledOptions) => {
    const isBuyer = me.isBuyer();
    const buyerBuildOrder = flags?.buildOrderBuyerEnabled;
    const notNewProductDetails = !me.new_product_details;
    const buyerCanOrder = me.hasPermission("can_order");
    const featureFlag = siteConfig.BUILD_ORDER_FLOW_ENABLED === "true";
    const brandBuildOrder = scope?.brand?.hasPreference("build_order");
    const brandMultiDeliveryOrdering = scope?.brand?.hasPreference("multiple_delivery_ordering");

    return (
        isBuyer &&
        buyerBuildOrder &&
        (ignoreNewPdp || notNewProductDetails) &&
        buyerCanOrder &&
        featureFlag &&
        brandBuildOrder &&
        brandMultiDeliveryOrdering
    );
};

/**
 * Provides a hatchway to the build order context.
 */
export const useBuildOrder = () => {
    const { scope, me } = useApp();
    const flags = useFlags();

    const isBuildOrderEnabled = hasBuildOrderEnabled({ scope, me, flags });

    return { isBuildOrderEnabled };
};
